import React from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { findHighlightColor, findDay, timeConvert } from "./ContactPageTools";
import { connect } from "react-redux";
import ReactPixel from "@bettercart/react-facebook-pixel";
import ReactGA from "react-ga4";
import { GTM } from "../../App";
import Button from "@material-ui/core/Button";

class SimpleExpansionPanel extends React.Component {
  mergeSlots = (slots) => {
    let temp = [];
    let ignoreSlots = [];
    slots.forEach((slot) => {
      if (
        !ignoreSlots.find(
          (s) =>
            s.day === slot.day && s.start === slot.start && s.end === slot.end
        )
      ) {
        const possibleMergeAfter = slots.find(
          (t) => t.day === (slot.day + 1) % 7
        );

        if (
          possibleMergeAfter &&
          possibleMergeAfter.start.startsWith("00:00") &&
          possibleMergeAfter.end <= "04:00:00" &&
          slot.end.startsWith("23:59")
        ) {
          temp.push({
            day: slot.day,
            start: slot.start,
            end: possibleMergeAfter.end,
          });
          ignoreSlots.push(possibleMergeAfter);
          let removeIndex = temp.findIndex(
            (t) =>
              t.day === possibleMergeAfter.day &&
              t.start === possibleMergeAfter.start &&
              t.end === possibleMergeAfter.end
          );
          if (removeIndex >= 0) {
            temp.splice(removeIndex, 1);
          }
        } else temp.push(slot);
      }
    });
    return temp;
  };
  renderSlots = (branch) => {
    const { language } = this.props;
    let slots = branch.slots;

    slots = this.mergeSlots(slots);

    let areSlotsEveryDay = slots.reduce((sum, slot) => sum + slot.day, 0) == 21;
    let areSlotsEqual =
      slots.filter(
        (slot) => slot.start == slots[0].start && slot.end == slots[0].end
      ).length == 7;

    if (areSlotsEveryDay && areSlotsEqual) {
      const slot = slots[0];
      return (
        <div className="row mb-2" style={{ width: "100%" }}>
          <div
            className={"col-6 m-0 pr-0 ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={{ paddingLeft: 60 }}
          >
            <p
              style={{
                display: "inline",
                marginRight: language == "english" ? 0 : 70,
              }}
            >
              {language == "english" ? "Everyday" : "كل يوم"}
            </p>
          </div>
          <div
            className={"col-6 m-0 ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
          >
            <p className="" style={{ display: "inline" }}>
              {timeConvert(slot.start, language)} -{" "}
              {timeConvert(slot.end, language)}
            </p>
          </div>
        </div>
      );
    }
    return slots.map((slot) => (
      <div className="row mb-2" style={{ width: "100%" }}>
        <div
          className={"col-6 m-0 pr-0 ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
          style={{ paddingLeft: 60 }}
        >
          <p
            style={{
              display: "inline",
              marginRight: language == "english" ? 0 : 70,
            }}
          >
            {findDay(slot.day, language)}
          </p>
        </div>
        <div
          className={"col-6 m-0 ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
        >
          <p className="" style={{ display: "inline" }}>
            {timeConvert(slot.start, language)} -{" "}
            {timeConvert(slot.end, language)}
          </p>
        </div>
      </div>
    ));
  };
  render() {
    const language = this.props.language;
    const classes = {
      root: {
        width: "100%",
      },
      heading: {
        fontSize: 15,
      },
    };
    const handleExpansionChange = (e, expanded, indx) => {
      if (expanded) {
        this.props.addAccordion(indx);

        if (
          this.props.settings.enable_fb_pixel &&
          this.props.settings.fb_pixel
        ) {
          ReactPixel.track("FindLocation");
        }
        if (
          this.props.settings.enable_google_analytics &&
          this.props.settings.google_analytics
        ) {
          ReactGA.event({
            category: "FindLocation",
            action: `User Tried to Find the Location of a Branch`,
            label: "FindLocation",
          });
        }
        if (GTM) {
          GTM.track("find_location");
        }
      } else {
        this.props.removeAccordion(indx);
      }
    };
    const branches = this.props.branches
      .filter((b) => !b.hide_branch)
      .map((branch, indx) => {
        return (
          <ExpansionPanel
            key={"ExpansionPanel" + indx}
            defaultExpanded={indx == 0 && true}
            ref={branch.name.replace(" ", "_")}
            className={
              language == "english"
                ? "accordionBorderEnglish"
                : "accordionBorderArabic"
            }
            style={{
              paddingBottom: 16,
              direction: language == "english" ? "ltr" : "rtl",
              margin: 0,

              borderLeftColor:
                language == "english"
                  ? findHighlightColor(indx)
                  : "transparent",
              borderRightColor:
                language == "arabic" ? findHighlightColor(indx) : "transparent",
            }}
            onChange={(e, expanded) => handleExpansionChange(e, expanded, indx)}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{ paddingLeft: language == "english" ? 20 : 5 }}
            >
              <Typography>
                {language == "english" ? branch.name : branch.ar_name}
              </Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails style={{ display: "block", padding: 0 }}>
              {this.renderSlots(branch)}
              <div
                className="row"
                style={{ height: 80, transform: "scale(0.85)" }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                {branch.contact_number && (
                  <div className="col align-self-center p-0">
                    <a href={`tel:${branch.contact_number}`}>
                      <Button variant="outlined" color="primary">
                        {language == "english"
                          ? "Call Branch"
                          : "الاتصال بالفرع"}
                      </Button>
                    </a>
                  </div>
                )}
                {branch.lat && branch.lng ? (
                  <div className="col align-self-center p-0">
                    <a
                      href={`https://maps.google.com/maps?daddr=${branch.lat},${branch.lng}`}
                    >
                      <Button variant="outlined" color="primary">
                        {language == "english"
                          ? "Get Directions"
                          : "اتجاهات القيادة"}
                      </Button>
                    </a>
                  </div>
                ) : null}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      });

    return <div className={classes.root}>{branches}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(SimpleExpansionPanel);
